import React, { useState } from "react";
import { Button, Box, Grid, styled } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import DebounceInput from "../DebouncerInput";
import styles from "./styles.module.css";
import GenericAutoComplete from "../GenericAutoComplete";
import AutoCompleteGenericGrupoECnpj from "../AutoCompleteGenericGrupoECnpj";
import EmpresaCnpjAutocomplete from "../AutoCompleteEmpresaCnpj";
import GenericYearMonthPicker from "../../components/GenericYearMonthPicker";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import GenericDatePicker from "../../components/GenericDatePicker";

const CRUDPageHeader = ({
  headerIcon,
  headerTitle,
  handleDebounceChange,
  handleOpenModal,
  modalButtonLabel,
  disableModalButton,
  AutoCompleteRequired,
  AutoComplete,
  handleDate,
  labelDate,
  datePicker,
  handleDateRange,
  labelDateRangeStart,
  labelDateRangeEnd,
  dateRangePicker,
  handleAutoCompleteChange,
  AutoCompleteGrupoECnpj,
  handleGrupoECnpjChange,
  AutoCompleteEmpresaCnpj,
  handleEmpresaCnpjChange,
  empresaInicial,
  multipleCnpj,
  disableSearch,
  buttonUpload,
  handleUpload,
  refUpload,
  customModalDisable,
}) => {
  const [filterValue, setFilterValue] = useState("");
  const [wasCnpjSet, setWasCnpjSet] = useState(false);

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return (
    <Box className={styles.backgroundHeader}>
      <div className={styles.linhaTitulo} />
      <Grid
        container
        spacing={1}
        sx={{
          lineHeight: "1",
        }}
      >
        <Grid
          item
          xs={3}
          sx={{ display: "flex", flexDirection: "row", alignItems: "start" }}
        >
          <div className={styles.iconeTitulo}>{headerIcon}</div>
          <div className={styles.tituloContainer}>
            <h1 className={styles.titulo}>{headerTitle}</h1>
          </div>
        </Grid>

        <Grid
          item
          xs={disableModalButton ? (disableSearch ? 9 : 6) : 5}
          className={styles.containerAutocomplete}
        >
          {AutoComplete ? (
            <Grid container spacing={2} justifyContent={"flex-end"}>
              {AutoComplete.map((index) => (
                <Grid item key={"AutoComplete-" + index} xs={6}>
                  <GenericAutoComplete
                    codigoCombo={index}
                    onChange={handleAutoCompleteChange}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={2}>
              {AutoCompleteEmpresaCnpj && (
                <Grid item xs={datePicker || dateRangePicker ? 9 : 12}>
                  <EmpresaCnpjAutocomplete
                    empresaInicial={empresaInicial}
                    onChange={(ids) => {
                      const cnpj = ids.CNPJ;
                      const temCnpj =
                        Array.isArray(cnpj)
                          ? cnpj.length > 0
                          : cnpj != null && cnpj !== "";
                      setWasCnpjSet(temCnpj);
                      handleEmpresaCnpjChange(ids);
                    }}
                  />
                </Grid>
              )}
              {AutoCompleteGrupoECnpj && !AutoCompleteEmpresaCnpj && (
                <Grid item xs={datePicker || dateRangePicker ? 9 : 12}>
                  <AutoCompleteGenericGrupoECnpj
                    onChange={(ids) => {
                      const cnpj = ids.CNPJ;
                      const temCnpj = Array.isArray(cnpj)
                        ? cnpj.length > 0
                        : cnpj != null && cnpj !== "";
                      setWasCnpjSet(temCnpj);
                      handleGrupoECnpjChange(ids);
                    }}
                    multiple={multipleCnpj}
                  />
                </Grid>
              )}
              {datePicker ? (
                <Grid item xs={3}>
                  <GenericYearMonthPicker
                    className={styles.yearMonth}
                    variant="standard"
                    onChange={handleDate}
                    label={labelDate}
                  />
                </Grid>
              ) : (
                ""
              )}
              {dateRangePicker ? (
                <Grid item xs={3}>
                  <Box mb={1}>
                    <GenericDatePicker
                      className={styles.yearMonth}
                      variant="standard"
                      onChange={(val) => handleDateRange(val, "start")}
                      label={labelDateRangeStart}
                    />
                  </Box>
                  <GenericDatePicker
                    className={styles.yearMonth}
                    variant="standard"
                    onChange={(val) => handleDateRange(val, "end")}
                    label={labelDateRangeEnd}
                  />
                </Grid>
              ) : (
                ""
              )}
            </Grid>
          )}
        </Grid>

        <Grid item xs={disableModalButton ? 3 : 4}>
          <Grid container>
            {!disableSearch && (
              <Grid item xs={disableModalButton ? 12 : 8}>
                {/* <Grid item xs={8}> */}
                <div className={styles.campoBusca}>
                  <SearchIcon className={styles.iconeBusca} />
                  <DebounceInput
                    className={styles.txtBuscaTabela}
                    fullWidth
                    size="small"
                    variant="outlined"
                    name="busca"
                    type="search"
                    placeholder="Filtrar…"
                    debounceTimeout={500}
                    handleChange={handleDebounceChange}
                    filterValue={filterValue}
                    setFilterValue={setFilterValue}
                  />
                </div>
              </Grid>
            )}
            {(buttonUpload) && (
              <Grid item xs={4} className={styles.buttonPadding}>
                <Button
                  disabled={
                    (AutoCompleteGrupoECnpj ||
                      AutoCompleteEmpresaCnpj) &&
                    !wasCnpjSet
                  }
                  component="label"
                  variant="contained"
                  className={styles.botaoNovo}
                  startIcon={<CloudUploadIcon />}
                >
                  Importar
                  <VisuallyHiddenInput
                    type="file"
                    ref={refUpload}
                    onChange={handleUpload}
                  />
                </Button>
              </Grid>
            )}
            {!disableModalButton && !buttonUpload && (
              <Grid item xs={4} className={styles.buttonPadding}>
                <Button
                  disabled={
                    customModalDisable
                      ? customModalDisable
                      : ((AutoCompleteGrupoECnpj ||
                          AutoCompleteEmpresaCnpj) &&
                          !wasCnpjSet)
                  }
                  className={styles.botaoNovo}
                  onClick={(event) => {
                    if (
                      (!AutoCompleteGrupoECnpj && !AutoCompleteEmpresaCnpj) ||
                      wasCnpjSet
                    ) {
                      handleOpenModal(event);
                    }
                  }}
                  size="small"
                >
                  {modalButtonLabel}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

CRUDPageHeader.propTypes = {
  headerIcon: PropTypes.object.isRequired,
  headerTitle: PropTypes.string.isRequired,
  // handleDebounceChange: PropTypes.func.isRequired,
  // handleOpenModal: PropTypes.func.isRequired,
};

export default CRUDPageHeader;
